<template>
  <div
    v-if="shouldRenderConfig && getFactsheet"
    :class="getClassName"
    class="matrix_table"
  >
    <div
      v-for="(value, prodPartCode) in getFactsheet"
      :key="prodPartCode"
      :class="getClassNameContainer"
    >
      <div :class="getClassName + 'Header'">
        {{ value.name }}
      </div>
      <div
        v-for="(fileData, fileKey) in value.files"
        :key="fileKey"
        :class="getClassNameItem"
      >
        <a :href="fileData.path" target="_blank" :title="fileData.name">
          {{ fileData.name }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useChangeOptionsStore, ["getFactsheet"]),
    name: () => {
      return "Factsheet";
    }
  }
};
</script>
